module.exports = __webpack_public_path__ + "img/ALLOSURVIE_Logo_texte_FR.f2ce6f56.svg";